import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import common from './en/common_en.json'

export const resources = {
  en: {
    translation: { ...common }
  }
} as const

i18n.use(initReactI18next).init({
  returnNull: false,
  resources,
  lng: 'en',
  keySeparator: '.',
  interpolation: {
    escapeValue: false
  }
})

export default i18n
